import React, { useEffect, useState } from 'react'
import {
  Row,
  Col,
  Form,
  Input,
  Button,
  Dropdown,
  Modal,
  Checkbox,
  Menu,
  Tooltip,
} from 'antd'

import {
  CheckCircleOutlined,
  CloseCircleOutlined,
  SaveOutlined,
  MoreOutlined,
  PlayCircleOutlined,
  ExclamationCircleOutlined,
  ExceptionOutlined,
} from '@ant-design/icons'
import {
  projectKickOff,
  projectComplete,
  projectRegister,
  projectHold,
  projectUnHold,
  projectCancel,
  projectReject,
  projectSkip,
  projectApprove,
} from 'api/Project/status'
import { getCookie } from 'helper/cookie'
import { useHistory } from 'react-router-dom'
import lang from '../../../../lang/en'
import { deleteProject } from 'api/Project/project'
import ModalCopy from 'common/Project/modalCopy'
const initalState = {
  data: [],
  isLoading: true,
  check: 'Y',
  visibleModal: false,
  visibleBtn: true,
}
let textReject = 'btnStatus_title_rejectKickoff'
let textApprove = 'btnStatus_title_ApproveRegis'
const { TextArea } = Input

const ButtonStatus = (props) => {
  const { idEditPRJ, projectHaveApproval, userCanApprove, form, permission } = props
  const [visibleModal, setVisibleModal] = useState(initalState.visibleModal)
  const [visibleModalDelete, setVisibleModalDelete] = useState(initalState.visibleModal)
  const [visibleModalHold, setVisibleModalHold] = useState(initalState.visibleModal)
  const [visibleModalUnhold, setVisibleModalUnhold] = useState(initalState.visibleModal)
  const [visibleModalCancel, setVisibleModalCancel] = useState(initalState.visibleModal)
  const [visibleModalApprove, setVisibleModalApprove] = useState(initalState.visibleModal)
  const [visibleModalReject, setVisibleModalReject] = useState(initalState.visibleModal)
  const [visibleModalSkip, setVisibleModalSkip] = useState(initalState.visibleModal)
  const [check, setCheck] = useState(initalState.check)
  const [valueCheck, setValueCheck] = useState(true)
  const [form_hold] = Form.useForm()
  const [form_reject] = Form.useForm()
  const [form_cancelApprove] = Form.useForm()
  const [form_unHold] = Form.useForm()
  const [form_cancel] = Form.useForm()
  const token = getCookie('access_token_admin')
  const language = getCookie('lang')
  const roleUser = parseInt(getCookie('roleUser'))
  const word = lang[language]
  const history = useHistory()
  const [visibleModalCopy, setVisibleModalCopy] = useState(false)

  const checkboxApprove = (type) => {
    if (projectHaveApproval === true) {
      return (
        <Checkbox
          className='checkbox'
          value={check}
          checked={valueCheck}
          onChange={onChangeCheckBox}
          style={{ alignSelf: type === 'hold' ? 'end' : 'unset' }}
        >
          Require Approval
        </Checkbox>
      )
    } else {
      return (
        <Col>
          <Checkbox
            style={{
              display: 'flex',
              justifyContent: type === 'hold' ? 'end' : 'center',
              alignItems: 'center',
            }}
            value={check}
            disabled
            checked={false}
          >
            Require Approval
          </Checkbox>
          <p className='small'>
            If you want to request approval please set up permissions for approval
          </p>
        </Col>
      )
    }
  }
  const modalRegister = () => {
    return (
      <Modal
        maskClosable={false}
        className='ModalStatusOption'
        visible={visibleModal}
        okText={'Confirm'}
        onOk={handleOkRegis}
        onCancel={() => setVisibleModal(false)}
      >
        <CheckCircleOutlined className='Icon-style' />
        <h2>{word['btnStatus_title_register']}</h2>
        <h4>{word['btnStatus_des_register']}</h4>
        {checkboxApprove()}
      </Modal>
    )
  }
  const modalKickOff = () => {
    return (
      <Modal
        maskClosable={false}
        className='ModalStatusOption'
        visible={visibleModal}
        okText={'Confirm'}
        onOk={handleOkKickoff}
        onCancel={() => setVisibleModal(false)}
      >
        <CheckCircleOutlined className='Icon-style' />
        <h2>{word['btnStatus_title_kickoff']}</h2>
        <h4>{word['btnStatus_des_kickoff']}</h4>
        {checkboxApprove()}
      </Modal>
    )
  }
  const modalCompelete = () => {
    return (
      <Modal
        maskClosable={false}
        className='ModalStatusOption'
        visible={visibleModal}
        okText={'Confirm'}
        onOk={handleOkComplete}
        onCancel={() => setVisibleModal(false)}
      >
        <CheckCircleOutlined className='Icon-style' />
        <h2>{word['btnStatus_title_complete']}</h2>
        <h4>{word['btnStatus_des_complete']}</h4>
        {checkboxApprove()}
      </Modal>
    )
  }
  const modalSave = () => {
    return (
      <Modal
        maskClosable={false}
        className='ModalSaveDraft'
        visible={props.visibleSaveDraft}
        onOk={() => props.setVisibleSaveDraft(false)}
        onCancel={() => props.setVisibleSaveDraft(false)}
      >
        <CheckCircleOutlined className='Icon-style' />
        <h2>{word['btnStatus_title_save']}</h2>
        <h4>{word['btnStatus_des_save']}</h4>
      </Modal>
    )
  }

  const modalApprove = () => {
    return (
      <Modal
        maskClosable={false}
        className='ModalStatusOption'
        visible={visibleModalApprove}
        onOk={handleApprove}
        okText={'Approve'}
        onCancel={() => setVisibleModalApprove(false)}
      >
        <CheckCircleOutlined className='Icon-style' />
        <h2>{word[textApprove]}</h2>
        <h4>{word['btnStatus_des_approve']}</h4>
      </Modal>
    )
  }

  const modalDelete = () => {
    return (
      <Modal
        maskClosable={false}
        className='DeleteModal'
        visible={visibleModalDelete}
        okText={'Delete'}
        onOk={handleDelete}
        onCancel={() => setVisibleModalDelete(false)}
      >
        <CloseCircleOutlined className='CloseCircleOutlined' />
        <h2>{word['btnStatus_title_delete']}</h2>
        <h4>{word['btnStatus_des_delete']}</h4>
      </Modal>
    )
  }
  const modalCancel = () => {
    return (
      <Modal
        maskClosable={false}
        className='DeleteModal'
        visible={visibleModalCancel}
        okText={'Confirm'}
        onOk={form_cancel.submit}
        onCancel={() => setVisibleModalCancel(false)}
        destroyOnClose
      >
        <Form
          className='body-form'
          form={form_cancel}
          onFinish={handleCancel}
          name='form_cancel'
        >
          <CloseCircleOutlined className='CloseCircleOutlined' />
          <h2>{word['btnStatus_title_cancel']}</h2>
          <h4>{word['btnStatus_des_cancel']}</h4>
          <Form.Item
            className='subform'
            id='reason_cancel_form'
            name='reason_cancel_form'
            rules={[
              {
                whitespace: true,
                required: true,
                message: '* Please tell a reason',
              },
            ]}
          >
            <TextArea
              id='reason_cancel'
              name='reason_cancel'
              placeholder='Please tell a reason'
              autoSize={{ minRows: 1, maxRows: 4 }}
            />
          </Form.Item>
        </Form>
      </Modal>
    )
  }
  const modalHold = () => {
    return (
      <Modal
        maskClosable={false}
        className='ModalStatusOption'
        visible={visibleModalHold}
        okText={'Confirm'}
        onOk={form_hold.submit}
        onCancel={() => setVisibleModalHold(false)}
        destroyOnClose
      >
        <Form
          className='body-form'
          form={form_hold}
          onFinish={handleHold}
          name='form_hold'
        >
          <ExclamationCircleOutlined className='exclamationCircleOutlined' />
          <h2>{word['btnStatus_title_hold']}</h2>
          <h4>{word['btnStatus_des_hold']}</h4>
          <Form.Item
            className='subform'
            id='reason_hold_form'
            name='reason_hold_form'
            rules={[
              {
                whitespace: true,
                required: true,
                message: '* Please tell a reason',
              },
            ]}
          >
            <TextArea
              id='reason_hold'
              name='reason_hold'
              placeholder='Please tell a reason'
              autoSize={{ minRows: 1, maxRows: 4 }}
            />
          </Form.Item>
          {checkboxApprove('hold')}
        </Form>
      </Modal>
    )
  }
  const modalReject = () => {
    return (
      <Modal
        maskClosable={false}
        className='ModalStatusOption'
        visible={visibleModalReject}
        okText={'Reject'}
        onOk={form_reject.submit}
        onCancel={() => setVisibleModalReject(false)}
        destroyOnClose
      >
        <Form
          className='body-form'
          form={form_reject}
          onFinish={handleReject}
          name='form_reject'
        >
          <CloseCircleOutlined className='CloseCircleOutlined' />
          <h2>{word[textReject]}</h2>
          <h4>{word['btnStatus_des_reject']}</h4>
          <Form.Item
            className='subform'
            id='reason_reject_form'
            name='reason_reject_form'
            rules={[
              {
                whitespace: true,
                required: true,
                message: '* Please tell a reason',
              },
            ]}
          >
            <TextArea
              id='reason_reject'
              name='reason_reject'
              placeholder='Please tell a reason'
              autoSize={{ minRows: 1, maxRows: 4 }}
            />
          </Form.Item>
        </Form>
      </Modal>
    )
  }
  const modalUnHold = () => {
    return (
      <Modal
        maskClosable={false}
        className='ModalStatusOption'
        visible={visibleModalUnhold}
        okText={'Confirm'}
        onOk={form_unHold.submit}
        onCancel={() => setVisibleModalUnhold(false)}
        destroyOnClose
      >
        <Form
          name='form_unHold'
          form={form_unHold}
          className='body-form'
          onFinish={handleUnhold}
        >
          <PlayCircleOutlined className='Icon-style' />
          <h2>{word['btnStatus_title_unhold']}</h2>
          <h4>{word['btnStatus_des_unhold']}</h4>
          <Form.Item
            className='subform'
            id='reason_unHold_form'
            name='reason_unHold_form'
            rules={[
              {
                whitespace: true,
                required: true,
                message: '* Please tell a reason',
              },
            ]}
          >
            <TextArea
              id='reason_unHold'
              name='reason_unHold'
              placeholder='Please tell a reason'
              autoSize={{ minRows: 1, maxRows: 4 }}
            />
          </Form.Item>
        </Form>
      </Modal>
    )
  }
  const modalSkip = () => {
    return (
      <Modal
        maskClosable={false}
        className='ModalStatusOption'
        visible={visibleModalSkip}
        onOk={form_cancelApprove.submit}
        okText={'Confirm'}
        cancelText={'Close'}
        onCancel={() => setVisibleModalSkip(false)}
        destroyOnClose
      >
        <Form
          name='form_cancelApprove'
          form={form_cancelApprove}
          className='body-form'
          onFinish={handleSkip}
        >
          <ExceptionOutlined className='ExceptionOutlined' />
          <h2>{word['btnStatus_title_skip']}</h2>
          <h4>{word['btnStatus_des_skip']}</h4>
          <Form.Item
            className='subform'
            id='reason_cancelApprove_form'
            name='reason_cancelApprove_form'
            rules={[
              {
                whitespace: true,
                required: true,
                message: '* Please tell a reason',
              },
            ]}
          >
            <TextArea
              id='reason_cancelApprove'
              name='reason_cancelApprove'
              placeholder='Please tell a reason'
              autoSize={{ minRows: 1, maxRows: 4 }}
            />
          </Form.Item>
        </Form>
      </Modal>
    )
  }
  const onChangeCheckBox = (value) => {
    setValueCheck(!valueCheck)
    if (!value.target.checked) {
      setCheck('N')
    } else {
      setCheck('Y')
    }
  }
  const handleApprove = () => {
    const data = {
      project_id: parseInt(idEditPRJ),
    }
    try {
      projectApprove({
        params: data,
        token: token,
      }).then((res) => {
        history.push({
          pathname: '/project-list',
        })
      })
    } catch (error) {
      console.log(error)
    }
    setVisibleModalApprove(false)
  }
  const handleOkKickoff = () => {
    let data = {}
    if (projectHaveApproval === false) {
      data = {
        project_id: parseInt(idEditPRJ),
        approve: 'N',
      }
    } else {
      data = {
        project_id: parseInt(idEditPRJ),
        approve: check,
      }
    }
    try {
      projectKickOff({
        params: data,
        token: token,
      }).then((res) => {
        history.push({
          pathname: '/project-list',
        })
      })
    } catch (error) {
      console.log(error)
    }
    setVisibleModal(false)
  }
  const handleOkRegis = () => {
    let data = {}
    if (projectHaveApproval === false) {
      data = {
        project_id: parseInt(idEditPRJ),
        approve: 'N',
      }
    } else {
      data = {
        project_id: parseInt(idEditPRJ),
        approve: check,
      }
    }
    try {
      projectRegister({
        params: data,
        token: token,
      }).then((res) => {
        history.push({
          pathname: '/project-list',
        })
      })
    } catch (error) {
      console.log(error)
    }
    setVisibleModal(false)
  }
  const handleCancel = (value) => {
    const data = {
      project_id: parseInt(idEditPRJ),
      remark: value.reason_cancel_form,
    }
    try {
      projectCancel({
        params: data,
        token: token,
      }).then((res) => {
        history.push({
          pathname: '/project-list',
        })
      })
    } catch (error) {
      console.log(error)
    }
    setVisibleModalCancel(false)
  }
  const handleOkComplete = () => {
    let data = {}
    if (projectHaveApproval === false) {
      data = {
        project_id: parseInt(idEditPRJ),
        approve: 'N',
      }
    } else {
      data = {
        project_id: parseInt(idEditPRJ),
        approve: check,
      }
    }
    try {
      projectComplete({
        params: data,
        token: token,
      }).then((res) => {
        history.push({
          pathname: '/project-list',
        })
      })
    } catch (error) {
      console.log(error)
    }
    setVisibleModal(false)
  }
  const handleDelete = () => {
    try {
      deleteProject({
        project_id: parseInt(idEditPRJ),
        token: token,
      }).then((res) => {
        history.push({
          pathname: '/project-list',
        })
      })
    } catch (error) {
      console.log(error)
    }
    setVisibleModalDelete(false)
  }
  const onSkip = () => {
    setVisibleModalSkip(true)
    form_cancelApprove.setFieldsValue({
      reason_cancelApprove_form: null,
    })
  }
  const handleSkip = (value) => {
    const data = {
      project_id: parseInt(idEditPRJ),
      remark: value.reason_cancelApprove_form,
    }
    try {
      projectSkip({
        params: data,
        token: token,
      }).then((res) => {
        history.push({
          pathname: '/project-list',
        })
      })
    } catch (error) {
      console.log(error)
    }
    setVisibleModalSkip(false)
  }
  const handleUnhold = (value) => {
    const data = {
      project_id: parseInt(idEditPRJ),
      remark: value.reason_unHold_form,
    }
    try {
      projectUnHold({
        params: data,
        token: token,
      }).then((res) => {
        history.push({
          pathname: '/project-list',
        })
      })
    } catch (error) {
      console.log(error)
    }
    setVisibleModalUnhold(false)
  }
  const onHold = () => {
    form_hold.setFieldsValue({
      reason_hold_form: null,
    })
    setVisibleModalHold(true)
  }
  const onUnHold = () => {
    form_unHold.setFieldsValue({
      reason_unHold_form: null,
    })
    setVisibleModalUnhold(true)
  }
  const onCancel = () => {
    form_cancel.setFieldsValue({
      reason_cancel_form: null,
    })
    setVisibleModalCancel(true)
  }
  const handleHold = (value) => {
    let data = {}
    if (projectHaveApproval === false) {
      data = {
        project_id: parseInt(idEditPRJ),
        remark: value.reason_hold_form,
        approve: 'N',
      }
    } else {
      data = {
        project_id: parseInt(idEditPRJ),
        remark: value.reason_hold_form,
        approve: check,
      }
    }
    try {
      projectHold({
        params: data,
        token: token,
      }).then((res) => {
        history.push({
          pathname: '/project-list',
        })
      })
    } catch (error) {
      console.log(error)
    }
    setVisibleModalHold(false)
  }
  const onReject = () => {
    form_reject.setFieldsValue({
      reason_reject_form: null,
    })
    setVisibleModalReject(true)
  }
  const handleReject = (value) => {
    const data = {
      project_id: parseInt(idEditPRJ),
      remark: value.reason_reject_form,
    }
    try {
      projectReject({
        params: data,
        token: token,
      }).then((res) => {
        history.push({
          pathname: '/project-list',
        })
      })
    } catch (error) {
      console.log(error)
    }
    setVisibleModalReject(false)
  }

  const goOverView = (data) => {
    history.push({
      pathname: `/overview/${data}`,
    })
  }
  const goActivity = (data) => {
    history.push({
      pathname: `/activity/${data}`,
    })
  }
  const goReschedule = (data) => {
    history.push({
      pathname: `/reschedule/${data}`,
    })
  }

  const handleCopyProject = (data) => {
    setVisibleModalCopy(true)
  }
  const modalCopy = () => {
    return (
      <ModalCopy
        visibleModalCopy={visibleModalCopy}
        setVisibleModalCopy={setVisibleModalCopy}
        type={'project'}
        id_project={idEditPRJ}
      />
    )
  }

  const menuCopy = () => {
    return (
      <Menu.Item
        key='3'
        onClick={() => handleCopyProject(idEditPRJ)}
        hidden={permission.create ? false : true}
      >
        Copy
      </Menu.Item>
    )
  }
  const menuViewOverview = () => {
    return (
      <Menu.Item key='0' onClick={() => goOverView(idEditPRJ)}>
        View Overview
      </Menu.Item>
    )
  }
  const menuProjectActivity = () => {
    return (
      <Menu.Item key='1' onClick={() => goActivity(idEditPRJ)}>
        Project Activity
      </Menu.Item>
    )
  }
  const menuReschedule = () => {
    return (
      <Menu.Item
        key='2'
        onClick={() => goReschedule(idEditPRJ)}
        hidden={permission.update ? false : true}
      >
        Reschedule
      </Menu.Item>
    )
  }
  const menuCancelProject = () => {
    return (
      <Menu.Item key='4' onClick={onCancel} hidden={permission.update ? false : true}>
        Cancel Project
      </Menu.Item>
    )
  }
  const menuCancelApproval = () => {
    return (
      <Menu.Item key='5' onClick={onSkip} hidden={permission.update ? false : true}>
        Cancel Approval
      </Menu.Item>
    )
  }
  const menuDelete = () => {
    return (
      <Menu.Item
        key='4'
        onClick={() => setVisibleModalDelete(true)}
        hidden={permission.delete ? false : true}
      // hidden={!((permission.delete) || (permission.delete && permission.menu_id === 3))}
      >
        Delete
      </Menu.Item>
    )
  }
  const menuHold = () => {
    return (
      <Menu.Item key='5' onClick={onHold} hidden={permission.update ? false : true}>
        Hold
      </Menu.Item>
    )
  }

  const menu = (type) => {
    if (type === '3') {
      //status Waiting for Register
      return (
        <Menu className='dropdrown-option'>
          {menuViewOverview()}
          {menuProjectActivity()}
          {menuReschedule()}
          {menuCopy()}
          {menuCancelProject()}
          {permission.delete && permission.menu_id === 3 || permission.menu_id === 25 ? menuDelete() : ''}
          {menuCancelApproval()}
        </Menu>
      )
    } else if (type === '2') {
      //status Save
      return (
        <Menu className='dropdrown-option'>
          {menuViewOverview()}
          {menuProjectActivity()}
          {menuReschedule()}
          {menuCopy()}
          {menuDelete()}
        </Menu>
      )
    } else if (type === '5') {
      //status Waiting for Kickoff
      return (
        <Menu className='dropdrown-option'>
          {menuViewOverview()}
          {menuProjectActivity()}
          {menuReschedule()}
          {menuCopy()}
          {menuCancelProject()}
          {permission.delete && permission.menu_id === 3 || permission.menu_id === 25 ? menuDelete() : ''}
          {menuCancelApproval()}
        </Menu>
      )
    } else if (type === '4') {
      //status Register
      return (
        <Menu className='dropdrown-option'>
          {menuViewOverview()}
          {menuProjectActivity()}
          {menuReschedule()}
          {menuCopy()}
          {menuCancelProject()}
          {permission.delete && permission.menu_id === 3 || permission.menu_id === 25 ? menuDelete() : ''}
        </Menu>
      )
    } else if (type === '6') {
      //status Kickoff
      return (
        <Menu className='dropdrown-option'>
          {menuViewOverview()}
          {menuProjectActivity()}
          {menuReschedule()}
          {menuCopy()}
          {menuCancelProject()}
          {menuHold()}
          {permission.delete && permission.menu_id === 3 || permission.menu_id === 25 ? menuDelete() : ''}
        </Menu>
      )
    } else if (type === '7') {
      //status Hold
      return (
        <Menu className='dropdrown-option'>
          {menuViewOverview()}
          {menuProjectActivity()}
          {menuReschedule()}
          {menuCopy()}
          {menuCancelProject()}
          {permission.delete && permission.menu_id === 3 || permission.menu_id === 25 ? menuDelete() : ''}
        </Menu>
      )
    } else if (type === '8') {
      //status Waiting for Complete
      return (
        <Menu className='dropdrown-option'>
          {menuViewOverview()}
          {menuProjectActivity()}
          {menuReschedule()}
          {menuCopy()}
          {menuCancelProject()}
          {permission.delete && permission.menu_id === 3 || permission.menu_id === 25 ? menuDelete() : ''}
          {menuCancelApproval()}
        </Menu>
      )
    } else if (type === '9') {
      // status Complete
      return (
        <Menu className='dropdrown-option'>
          {menuViewOverview()}
          {menuProjectActivity()}
          {menuReschedule()}
          {menuCopy()}
          {permission.delete && permission.menu_id === 3 || permission.menu_id === 25 ? menuDelete() : ''}
        </Menu>
      )
    } else if (type === '19') {
      // status Cancelled
      return (
        <Menu className='dropdrown-option'>
          {menuViewOverview()}
          {menuProjectActivity()}
          {menuReschedule()}
          {menuCopy()}
          {permission.delete && permission.menu_id === 3 || permission.menu_id === 25 ? menuDelete() : ''}
        </Menu>
      )
    } else if (type === '21') {
      // status Completed with Delay
      return (
        <Menu className='dropdrown-option'>
          {menuViewOverview()}
          {menuProjectActivity()}
          {menuReschedule()}
          {menuCopy()}
          {permission.delete && permission.menu_id === 3 || permission.menu_id === 25 ? menuDelete() : ''}
        </Menu>
      )
    } else if (type === '28') {
      //status Waiting for Complete
      return (
        <Menu className='dropdrown-option'>
          {menuViewOverview()}
          {menuProjectActivity()}
          {menuReschedule()}
          {menuCopy()}
          {menuCancelProject()}
          {permission.delete && permission.menu_id === 3 || permission.menu_id === 25 ? menuDelete() : ''}
          {menuCancelApproval()}
        </Menu>
      )
    }
  }
  const ApproveReject = () => {
    return (
      <div className='RegisSave-Container'>
        <div className='absolute'>
          <Button id='btn_reject' className='BTN_Previous' onClick={onReject}>
            <CloseCircleOutlined className='Icon-color' />
            Reject
          </Button>
          <Row>
            <Button
              id='btn_approve'
              className='BTN_Next'
              onClick={() => setVisibleModalApprove(true)}
            >
              <CheckCircleOutlined className='Icon-color' />
              Approve
            </Button>
            <Dropdown
              key='option'
              trigger={['click']}
              overlay={(e) => menu(props.status_id)}
              placement='bottomRight'
            >
              <div
                hidden={!(userCanApprove.creator === true || permission.menu_id === 25)}
                className='option'
              >
                <MoreOutlined className='icon' />
              </div>
            </Dropdown>
          </Row>

          {modalReject()}
          {modalApprove()}
          {modalCancel()}
          {modalSkip()}
        </div>
      </div>
    )
  }

  const Dropdown_Option = () => {
    return (
      <Dropdown
        key='option'
        trigger={['click']}
        overlay={(e) => menu(props.status_id)}
        placement='bottomRight'
      >
        <div className='option' style={{ cursor: 'pointer' }}>
          <MoreOutlined className='icon' />
        </div>
      </Dropdown>
    )
  }

  const Button_Save = () => {
    return (
      <Button
        id='btn_save'
        className='BTN_ClassA'
        htmlType='submit'
        onClick={() => funcBtn_save()}
      >
        <SaveOutlined className='Icon-color' />
        Save
      </Button>
    )
  }
  const funcBtn_save = () => {
    // console.log('GET IN BTN SAVE')
    {
      form.submit()
    }
    props.setCheckBtn('save')
  }
  const Button_Register = () => {
    return (
      <Button
        id='btn_register'
        className='BTN_Next'
        disabled={props.visibleRegister}
        onClick={() => setVisibleModal(true)}
      >
        <CheckCircleOutlined className='Icon-color' />
        Register
      </Button>
    )
  }

  if (props.status_id !== undefined) {
    if (['3', '5', '8', '28'].includes(props.status_id)) {
      if (userCanApprove.approve === true) {
        switch (props.status_id) {
          case '3':
            textReject = 'btnStatus_title_rejectRegis'
            textApprove = 'btnStatus_title_approveRegis'
            return (
              <>
                {ApproveReject()} {modalCopy()}
              </>
            )
          case '5':
            textReject = 'btnStatus_title_rejectKickoff'
            textApprove = 'btnStatus_title_approveKickoff'
            return (
              <>
                {ApproveReject()}
                {modalCopy()}
              </>
            )
          case '8':
            textReject = 'btnStatus_title_rejectComplete'
            textApprove = 'btnStatus_title_approveComplete'
            return (
              <>
                {ApproveReject()} {modalCopy()}
              </>
            )
          case '28':
            textReject = 'btnStatus_title_rejectHold'
            textApprove = 'btnStatus_title_approveHold'
            return (
              <>
                {ApproveReject()}
                {modalCopy()}
              </>
            )
          default:
            return <> </>
            break
        }
      } else {
        switch (props.status_id) {
          case '3':
            return (
              <div className='RegisSave-Container'>
                <div className='absolute'>
                  {Button_Save()}
                  {Dropdown_Option()}
                  {modalSave()}
                  {modalCancel()}
                  {modalSkip()}
                  {modalCopy()}
                </div>
              </div>
            )
          case '5':
            return (
              <div className='RegisSave-Container'>
                <div className='absolute'>
                  {Button_Save()}
                  {Dropdown_Option()}
                  {modalSave()}
                  {modalCancel()}
                  {modalHold()}
                  {modalSkip()}
                  {modalCopy()}
                </div>
              </div>
            )
          case '8':
            return (
              <div className='RegisSave-Container'>
                <div className='absolute'>
                  {/* {Button_Save()}
                  {Dropdown_Option()} */}
                  {modalSave()}
                  {modalCancel()}
                  {modalSkip()}
                  {modalCopy()}
                </div>
              </div>
            )
          case '28':
            return (
              <div className='RegisSave-Container'>
                <div className='absolute'>
                  {Button_Save()}
                  {Dropdown_Option()}
                  {modalSave()}
                  {modalCancel()}
                  {modalSkip()}
                  {modalCopy()}
                </div>
              </div>
            )
          default:
            return <> </>
            break
        }
      }
    } else {
      if (userCanApprove.creator === true || userCanApprove.leader === true) { //flowเดิมเป็น userCanApprove.creator === true 
        let msgErrFlow = ''
        let msgErrPercent = ''
        if (userCanApprove.wordErr) {
          if (userCanApprove.planTaskSubTaskSuccess === false) {
            msgErrFlow = `Cannot ${props.status_id == 4 ? 'kick off' : props.status_id == 6 ? 'complete' : ''
              } the project because sprint task flow is incomplete some task and subtask no plandate`
          }
          if (userCanApprove.flow_complete === false) {
            msgErrFlow = `Cannot ${props.status_id == 4 ? 'kick off' : props.status_id == 6 ? 'complete' : ''
              } the project because sprint task flow is incomplete `
          }
        }
        if (userCanApprove.done_percent === false) {
          msgErrPercent =
            'Cannot complete the project because the tasks have not been completed'
        }
        //   Cannot complete the project because sprint task flow is incomplete
        switch (props.status_id) {
          //status create project
          case '1':
            return (
              <div className='DraftandRegis-Container'>
                <div className='absolute'>
                  <div>{Button_Save()}</div>
                  <Row>{Button_Register()}</Row>
                  {modalSave()}
                  {modalRegister()}
                </div>
              </div>
            )
          //status Save
          case '2':
            return (
              <div className='RegisSave-Container'>
                <div className='absolute'>
                  {Button_Save()}
                  <Row>
                    {Button_Register()}
                    {Dropdown_Option()}
                  </Row>
                  {modalSave()}
                  {modalRegister()}
                  {modalDelete()}
                  {modalCopy()}
                </div>
              </div>
            )
          //status Register
          case '4':
            return (
              <div className='RegisSave-Container'>
                <div className='absolute'>
                  {Button_Save()}
                  <Row>
                    {userCanApprove.flow_complete &&
                      userCanApprove.planTaskSubTaskSuccess ? (
                      <Button
                        id='btn_kickoff'
                        className='BTN_Next'
                        onClick={() => setVisibleModal(true)}
                        disabled={userCanApprove.flow_complete ? false : true}
                        style={{ height: 40, marginLeft: 8, borderRadius: 4 }}
                      >
                        <PlayCircleOutlined className='Icon-color' />
                        Kick off
                      </Button>
                    ) : (
                      <Tooltip title={msgErrFlow} placement='topLeft'>
                        <Button
                          id='btn_kickoff_disabled'
                          disabled
                          style={{ height: 40, marginLeft: 8, borderRadius: 4 }}
                        >
                          <PlayCircleOutlined className='Icon-color' />
                          Kick off
                        </Button>
                      </Tooltip>
                    )}
                    {Dropdown_Option()}
                  </Row>

                  {modalKickOff()}
                  {modalSave()}
                  {modalCancel()}
                  {modalCopy()}
                </div>
              </div>
            )
          //status Waiting for Kickoff
          case '5':

          //status Kickoff
          case '6':
            return (
              <div className='RegisSave-Container'>
                <div className='absolute'>
                  {Button_Save()}
                  <Row>
                    {userCanApprove.flow_complete &&
                      userCanApprove.planTaskSubTaskSuccess &&
                      userCanApprove.done_percent ? (
                      <Button
                        id='btn_complete'
                        className='BTN_Next'
                        onClick={() => setVisibleModal(true)}
                      >
                        <CheckCircleOutlined className='Icon-color' />
                        Complete
                      </Button>
                    ) : (
                      <Tooltip
                        title={msgErrFlow + ' ' + msgErrPercent}
                        placement='topLeft'
                      >
                        <Button
                          id='btn_complete_disabled'
                          style={{ height: 40, marginLeft: 8, borderRadius: 4 }}
                          disabled
                        >
                          <CheckCircleOutlined className='Icon-color' />
                          Complete
                        </Button>
                      </Tooltip>
                    )}

                    {Dropdown_Option()}
                  </Row>
                  {modalCompelete()}
                  {modalHold()}
                  {modalCancel()}
                  {modalSave()}
                  {modalCopy()}
                </div>
              </div>
            )
          //status Hold
          case '7':
            return (
              <div className='RegisSave-Container'>
                <div className='absolute'>
                  {Button_Save()}
                  <Row>
                    <Button id='btn_unhold' className='BTN_Next' onClick={onUnHold}>
                      <PlayCircleOutlined className='Icon-color' />
                      Unhold
                    </Button>

                    {Dropdown_Option()}
                  </Row>
                  {modalSave()}
                  {modalUnHold()}
                  {modalCancel()}
                  {modalCopy()}
                  {modalSkip()}
                </div>
              </div>
            )
          case '8':

          // status Complete
          case '9':
            return (
              <div className='RegisSave-Container'>
                <div className='absolute'>
                  <Row>{Dropdown_Option()}</Row>
                  {modalCopy()}
                </div>
              </div>
            )
          case '10':
            return <></>
          case '11':
            return <></>
          case '12':
            return <></>
          case '19':
            return (
              <div className='RegisSave-Container'>
                <div className='absolute'>
                  <Row>{Dropdown_Option()}</Row>
                  {modalCopy()}
                </div>
              </div>
            )
          case '21':
            return (
              <div className='RegisSave-Container'>
                <div className='absolute'>
                  <Row>{Dropdown_Option()}</Row>
                  {modalCopy()}
                </div>
              </div>
            )
          default:
            return <> </>
            break
        }
      } else {
        return <> </>
      }
    }
  }
}
export default ButtonStatus
